import React from 'react'
import PropTypes from 'prop-types'
import { Rows } from 'src/components'
import { ClearableInput } from 'src/components/inputs'
import { useIntl } from 'react-intl'
import { FilterIcon } from 'src/components/icons'
import SortedTable from '../SortedTable'

/**
 * A combination of a Table and an Input that acts as a filter.
 */
const FilterableTable = ({ inputProps, predicate, data, ...props }) => {
  const intl = useIntl()
  const [filter, setFilter] = React.useState('')
  const filteredData = filter ? data.filter(rowData => predicate({ intl, filter, rowData })) : data

  return (
    <Rows layout="auto 1">
      <ClearableInput
        value={filter}
        onChange={setFilter}
        icon={FilterIcon}
        placeholder={intl.formatMessage({ id: 'WEB_FILTER' })}
        {...inputProps}
      />
      <SortedTable data={filteredData} {...props} />
    </Rows>
  )
}

FilterableTable.propTypes = {
  /**
   * The table data.
   */
  data: PropTypes.array,
  /**
   * The predicate function.
   */
  predicate: PropTypes.func,
  /**
   * Props for the clearable input.
   */
  inputProps: PropTypes.object,
}

export default FilterableTable
